var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-title inline-block mr-10 px-3 leading-normal whitespace-no-wrap font-semibold label-title"},[_vm._t("default",[_vm._v("ラベルタイトル")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }